// Catalogue colour names are inconsistently cased - "Black" sits next to "LIGHT PINK". Only
// strings with no lower-case letter at all are treated as shouting and title-cased; anything
// already mixed-case is the catalogue's own styling and is left alone.
export default function formatOptionValueTitle(title: string): string {
  if (title.toUpperCase() !== title) {
    return title;
  }

  return title.toLowerCase().replace(/[^\s\-/]+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
}
